import styled from 'styled-components';

import { getThemeColor, getThemeFont, getThemeSize } from '../../../utils/theme';

export const AccordionHeaderS = styled.div`
  padding: 21px 28px 22px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-top: 2px solid ${getThemeColor(['grayBlue'])};

  & > span {
    font-family: ${getThemeFont(['regular'])};
    font-size: ${getThemeSize(['mediumText'])};
    font-weight: 700;
    line-height: 15.6px;
    text-align: left;
    color: #1d1d6cbf;
    display: flex;
    flex-direction: column;
  }

  & > svg {
    width: 18px;
    color: ${getThemeColor(['red'])};
    transform: ${({ isOpen }) => (isOpen ? 'rotate(-90deg)' : 'rotate(90deg)')};
    transition: transform 0.3s ease;
  }
`;

export const AccordionContentS = styled.div`
  overflow: hidden;
  padding: 3px 28px 30px;
`;
